import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { SectionTitle, EmptyState, Loader, Card } from "../components/ui-bits";
import { timeAgo } from "../lib/constants";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);

  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  const open = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`);
    if (n.meta?.conversation_id) nav(`/app/messages/${n.meta.conversation_id}`);
    else if (n.meta?.search_id) nav(`/app/search/${n.meta.search_id}`);
    else load();
  };

  if (items === null) return <Loader />;

  return (
    <div className="max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-2">
        <SectionTitle>Notifications</SectionTitle>
        {items.some((n) => !n.read) && (
          <button onClick={markAll} data-testid="mark-all-read-button" className="-mt-4 flex items-center gap-1.5 text-sm text-violet-400 hover:text-violet-300">
            <CheckCheck size={16} /> Tout marquer lu
          </button>
        )}
      </div>
      {items.length === 0 ? (
        <EmptyState icon={Bell} title="Aucune notification" desc="Tu seras notifié des réactions, téléchargements et messages." />
      ) : (
        <div className="space-y-2">
          {items.map((n) => (
            <Card key={n.id} onClick={() => open(n)} data-testid={`notification-${n.id}`}
              className={`p-4 flex items-start gap-3 cursor-pointer transition-colors ${n.read ? "opacity-70" : "border-violet-600/40 bg-violet-600/5"}`}>
              {!n.read && <span className="w-2 h-2 rounded-full bg-violet-500 mt-2 shrink-0" />}
              <div className={n.read ? "pl-5" : ""}>
                <p className="text-sm">{n.text}</p>
                <p className="text-xs text-zinc-500 mt-1">{timeAgo(n.created_at)}</p>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
